import { Component } from '@angular/core';
import { GridOptions } from 'ag-grid';

@Component({
  templateUrl: 'grid-page.html',
  styleUrls: ['grid-page.scss'],
})
export class GridPageComponent {

  rowData = [
    {
      firstName: 'Jay',
      lastName: 'David',
      email: 'test@firecoding.com',
      phone: '123-123-1234'
    },
    {
      firstName: 'Joe',
      lastName: 'Shmoe',
      email: 'test2@firecoding.com',
      phone: '216-613-3600'
    },
  ];

  gridOptions = <GridOptions>{
    columnDefs: [
      {
        headerName: 'First name',
        field: 'firstName',
        editable: true,
        width: 125,
      },
      {
        headerName: 'Last name',
        field: 'lastName',
        editable: true,
        sort: 'asc',
        width: 125,
      },
      {
        headerName: 'Email',
        field: 'email',
        editable: true,
        width: 250,
      },
      {
        headerName: 'Phone',
        field: 'phone',
        editable: true,
        width: 175,
      },
    ],

    defaultColDef: {
      filter: 'text',
    },

    rowSelection: 'single',

    rowHeight: 40,
  };




  constructor() {
  }


}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/grid-page/grid-page.ts